<template>
  <div class="flex flex-row">
    <div v-if='!editing' @click='editing = true' class="my-auto">
      <property-display-value-or-variable class="text-blue-800 underline cursor-pointer" :model='fakeModel' :schema='fakeSchema' />
    </div>
    <div v-else class="my-auto">
      <div class="fixed top-0 bottom-0 right-0 left-0" @click='editing = false' />
      <value-or-variable class="my-auto w-24" v-model='innerValue' :variables='variables'>
        <template #default='{}'>
          <numberer v-model="innerValue" />
        </template>
      </value-or-variable>
    </div>
  </div>
</template>
<script>
import PropertyDisplayValueOrVariable from '@/form/atoms/PropertyDisplayValueOrVariable.vue';
export default {
  props:{
    value:{
      type:[Number,String,Object],
      required:true
    },
    type:{
      type:String,
      default:'number'
    },
    label:{
      type:String,
      default:''
    },
    variables:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  data() {
    const fakeSchema = {
      inputType:this.type,
      unit:this.label,
      model:'value'
    }
    return {
      editing: false,
      innerValue: this.value,
      fakeSchema
    }
  },
  components:{
    PropertyDisplayValueOrVariable
  },
  watch:{
    innerValue(nv) {
      this.$emit('input', nv);
    }
  },
  computed:{
    fakeModel() {
      return {
        value:this.innerValue
      }
    }
  }
  
}
</script>
